module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TestAndParameters"
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(" Test & Parameters ")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": "",
      "md-align": "left"
    }
  }, [_c('md-input-container', {
    staticClass: "fixed-width-container"
  }, [_c('label', [_vm._v(" voltammetric test ")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "value": _vm.currentTest
    },
    on: {
      "change": _vm.onTestChange
    }
  }, _vm._l((_vm.testParamDefs), function(value, key) {
    return _c('md-option', {
      key: value.id,
      attrs: {
        "value": key
      }
    }, [_vm._v("  \n            " + _vm._s(value.name) + "  \n          ")])
  }))], 1)], 1), _vm._v(" "), _vm._l((_vm.currentTestParamDefs), function(paramDef, paramName) {
    return _c('md-layout', {
      key: paramDef.id,
      staticClass: "row-with-margin",
      attrs: {
        "md-row": "",
        "md-align": "left"
      }
    }, [(paramDef.type === 'list') ? _c('div', [_c('md-input-container', {
      class: {
        'fixed-width-container': true
      }
    }, [_c('label', [_vm._v(" current range " + _vm._s(_vm.currentTestParamDefs[paramName].unit) + " ")]), _vm._v(" "), _c('md-select', {
      attrs: {
        "value": _vm.currentTestParamVals[paramName]
      },
      on: {
        "change": function($event) {
          _vm.onListChange(paramName, $event)
        }
      }
    }, _vm._l((_vm.allowedCurrentRanges), function(value, key) {
      return _c('md-option', {
        key: value.id,
        attrs: {
          "value": key
        }
      }, [_vm._v("\n              " + _vm._s(value) + "\n            ")])
    }))], 1)], 1) : _vm._e(), _vm._v(" "), (paramDef.type === 'number') ? _c('div', [_c('md-input-container', {
      class: {
        'fixed-width-container': true, 'md-input-invalid': _vm.testParamErrs[_vm.currentTest][paramName].flag
      }
    }, [_c('label', [_vm._v(" " + _vm._s(paramDef.name) + " (" + _vm._s(paramDef.unit) + ")  ")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "type": "number",
        "value": _vm.testParamVals[_vm.currentTest][paramName],
        "step": _vm.testParamDefs[_vm.currentTest].defs[paramName].step
      },
      on: {
        "change": function($event) {
          _vm.onNumberChange(paramName, $event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "md-error"
    }, [_vm._v("\n            " + _vm._s(_vm.testParamErrs[_vm.currentTest][paramName].message) + "\n          ")])], 1), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "right"
      }
    }, [_vm._v(" \n          min = " + _vm._s(paramDef.minVal) + ", max = " + _vm._s(paramDef.maxVal) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (paramDef.type === 'radio') ? _c('div', _vm._l((_vm.testParamDefs[_vm.currentTest].defs[paramName].options), function(optionStr, optionKey) {
      return _c('md-radio', {
        key: optionStr.id,
        staticClass: "md-primary",
        attrs: {
          "value": _vm.testParamVals[_vm.currentTest][paramName],
          "md-value": optionKey
        },
        on: {
          "change": function($event) {
            _vm.onRadioChange(paramName, $event)
          }
        }
      }, [_vm._v("\n           " + _vm._s(optionStr) + "\n        ")])
    })) : _vm._e()])
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "row-with-margin",
    attrs: {
      "md-row": ""
    }
  }, [(_vm.showDebugButton) ? _c('md-button', {
    staticClass: "md-primary md-raised",
    on: {
      "click": _vm.onDebugClick
    }
  }, [_vm._v(" \n        Debug \n      ")]) : _vm._e()], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0403605d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TestAndParameters.vue
// module id = 162
// module chunks = 1